import {
  Box,
  Button,
  Modal,
  TextareaAutosize,
  TextField,
} from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React from "react";
import { postSavedQuery } from "../../../Apis/QueryApi";
import {
  SAVED_QUERY_MARKET_OPTIONS,
  UNDEFINED_MARKET_LABEL,
  UNDEFINED_MARKET_SELECT_VALUE,
  selectValueToSavedQueryMarketPayload,
} from "../../../constants/savedQueryMarkets";

const CreateQueryModal = ({ fetchData, open, setOpen, tabValue }) => {
  const [loading, setLoading] = React.useState(false);
  const [market, setMarket] = React.useState(UNDEFINED_MARKET_SELECT_VALUE);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setLoading(true);
    try {
      const fd = new FormData(form);
      const queryStr = String(fd.get("query") ?? "").trim();
      if (!queryStr) {
        return;
      }
      const payloadMarket = selectValueToSavedQueryMarketPayload(market);
      const data = {
        query: queryStr,
        description: String(fd.get("description") ?? ""),
        sport_type: tabValue,
      };
      if (payloadMarket != null) {
        data.market = payloadMarket;
      }
      const res = await postSavedQuery(data);
      console.log(res);
      if (res.status === 201) {
        setOpen(false);
        fetchData();
        form.reset();
        setMarket(UNDEFINED_MARKET_SELECT_VALUE);
      } else {
        window.alert(
          `Save did not complete (HTTP ${res.status}). Check the Network tab for save_query.`
        );
      }
    } catch (error) {
      const st = error.response && error.response.status;
      const errData = error.response && error.response.data;
      const errText =
        typeof errData === "string"
          ? errData
          : errData && (errData.error || errData.detail || errData.message);
      console.error(error.response);
      if (
        st === 403 &&
        typeof errText === "string" &&
        errText.toLowerCase().includes("already")
      ) {
        await fetchData();
        window.alert(
          `${errText} The list was refreshed. If the row is still missing, the GET request may be failing: check the browser Network tab for get_saved_query, or try another sport tab.`
        );
      } else if (errText) {
        window.alert(String(errText));
      } else {
        window.alert(
          "Save failed. Check the browser console and Network tab for save_query."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: "800px",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <h3 className="fs-3">Create SDQL Form</h3>
        <form onSubmit={(e) => handleSubmit(e)}>
          <TextField
            style={{ width: "100%", marginBottom: "20px" }}
            type="text"
            name="query"
            label="SDQL"
            variant="standard"
            required
          />

          <TextareaAutosize
            aria-label="Description"
            minRows={3}
            placeholder="Description"
            name="description"
            style={{
              width: "100%",
              marginBottom: "20px",
              borderRadius: "10px",
              borderColor: "rgba(0, 0, 0, 0.42)",
              padding: "10px",
            }}
          />

          <FormControl variant="standard" sx={{ minWidth: 200, marginBottom: "20px" }}>
            <InputLabel id="create-modal-market-label">Market</InputLabel>
            <Select
              labelId="create-modal-market-label"
              label="Market"
              value={market}
              onChange={(e) => setMarket(e.target.value)}
            >
              <MenuItem value={UNDEFINED_MARKET_SELECT_VALUE}>
                {UNDEFINED_MARKET_LABEL}
              </MenuItem>
              {SAVED_QUERY_MARKET_OPTIONS.map((m) => (
                <MenuItem key={m} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
          >
            save
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default CreateQueryModal;
